import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { markFormGroupTouched, jsonDeepParse } from 'src/app/controls/functions/shared-functions';
import { getInvalidFieldsV2, prepareFieldConfigFlagsNew } from 'src/app/functions/shared-functions';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';

@Component({
  selector: 'app-bank-details',
  templateUrl: './bank-details.component.html',
  styleUrls: ['./bank-details.component.scss']
})
export class BankDetailsComponent implements OnInit {


  bankDetailsForm: UntypedFormGroup = new UntypedFormGroup({
    bankNameId: new UntypedFormControl(null),
    bankName: new UntypedFormControl(null),
    bankAddressLine1: new UntypedFormControl(null),
    bankAddressLine2: new UntypedFormControl(null),
    bankPostalCode: new UntypedFormControl(null),
    bankCityId: new UntypedFormControl(null),
    bankCityName: new UntypedFormControl(null),
    bankStateId: new UntypedFormControl(null),
    bankStateName: new UntypedFormControl(null),
    bankCountryId: new UntypedFormControl(null),
    bankRefCode: new UntypedFormControl(null),
    bankAccountNumber: new UntypedFormControl(null),
    bankAttachments: new UntypedFormControl(null),
  })
  masters: any = {};
  field_config_access: any = {};
  uploadStatus = true;
  cityList = [];
  stateList = [];
  countryList = [];
  bankList = [];
  constructor(
    private dialog_ref: MatDialogRef<BankDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private translate: TranslateService,
    private notification: NotificationService
  ) { }

  ngOnInit(): void {
    if (this.data && this.data.resume_details) {
      console.log(this.data.resume_details)
      this.data.resume_details = jsonDeepParse(this.data.resume_details)
      this.bankDetailsForm.patchValue(this.data.resume_details);
    }
    if (this.data) {
      if (this.data.all_masters) {
        this.masters = this.data.all_masters;
        if (this.masters) {

          this.stateList = this.masters.stateList || [];
          this.countryList = this.masters.countryList || []

          if (this.masters) {
            if (this.masters.cityList && this.masters.cityList.length) {
              this.cityList = this.masters.cityList.filter(d => d.type == 1);
            }
            this.bankList = this.masters.bankNamesMasterList || [];

          }

        }
      }
      if (this.data.all_rights) {
        this.field_config_access = prepareFieldConfigFlagsNew(this.data.all_rights, this.bankDetailsForm, null, "RES_");
      }
    }
  }

  close() {
    this.dialog_ref.close()
  }
  save() {
    if (this.bankDetailsForm.valid && this.uploadStatus) {
      this.dialog_ref.close(this.bankDetailsForm.value);
    }
    else {
      if (!this.uploadStatus) {
        this.notification.error('ERROR.please_wait_while_attachments_being_uploaded', 'Close', 5000);
        return;
      }
      markFormGroupTouched(this.bankDetailsForm);
      getInvalidFieldsV2(this.bankDetailsForm, this.translate, this.notification, 'RESUME.', null, this.field_config_access, 'RES_');

    }
  }
  attachmentUploading(ev) {
    this.uploadStatus = ev;
  }
  cityChanged(ev) {
    if (ev) {
      if (!this.bankDetailsForm.value.bankStateId) {
        this.bankDetailsForm.patchValue({
          bankStateId: ev.stateId
        })
      }
    }
  }
}
